import { CALL_API } from 'redux-api-middleware'
import {
  BASE_URL,
  POSITION_GET_REQUEST,
  POSITION_GET_SUCCESS,
  POSITION_GET_FAILURE,
  POSITION_GET_RESET,
  POSITION_LIST_REQUEST,
  POSITION_LIST_SUCCESS,
  POSITION_LIST_FAILURE,
  POSITION_LIST_RESET,
  POSITION_CREATE_REQUEST,
  POSITION_CREATE_SUCCESS,
  POSITION_CREATE_FAILURE,
  POSITION_CREATE_RESET,
  POSITION_EDIT_REQUEST,
  POSITION_EDIT_SUCCESS,
  POSITION_EDIT_FAILURE,
  POSITION_EDIT_RESET,
  POSITION_DEACTIVATE_REQUEST,
  POSITION_DEACTIVATE_SUCCESS,
  POSITION_DEACTIVATE_FAILURE,
  POSITION_DEACTIVATE_RESET,
  POSITION_EXPORT_REQUEST,
  POSITION_EXPORT_SUCCESS,
  POSITION_EXPORT_FAILURE,
  POSITION_EXPORT_RESET,
  POSITION_IMPORT_REQUEST,
  POSITION_IMPORT_SUCCESS,
  POSITION_IMPORT_FAILURE,
  POSITION_IMPORT_RESET,
} from './../../constants'

export function createPosition(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions`,
      method: 'POST',
      types: [
        POSITION_CREATE_REQUEST,
        POSITION_CREATE_SUCCESS,
        POSITION_CREATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function getPosition(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions`,
      method: 'GET',
      types: [
        POSITION_LIST_REQUEST,
        POSITION_LIST_SUCCESS,
        POSITION_LIST_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function getPositionByID(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions/${id}`,
      method: 'GET',
      types: [
        POSITION_GET_REQUEST,
        POSITION_GET_SUCCESS,
        POSITION_GET_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function editPosition(id, payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions/${id}`,
      method: 'PUT',
      types: [
        POSITION_EDIT_REQUEST,
        POSITION_EDIT_SUCCESS,
        POSITION_EDIT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: JSON.stringify(payload),
    },
  }
}

export function deactivatePosition(id, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions/${id}/delete`,
      method: 'PUT',
      types: [
        POSITION_DEACTIVATE_REQUEST,
        POSITION_DEACTIVATE_SUCCESS,
        POSITION_DEACTIVATE_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function exportPosition(access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions/exports`,
      method: 'GET',
      types: [
        POSITION_EXPORT_REQUEST,
        POSITION_EXPORT_SUCCESS,
        POSITION_EXPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
    },
  }
}

export function importPosition(payload, access_token) {
  return {
    [CALL_API]: {
      endpoint: `${BASE_URL}/positions/imports`,
      method: 'POST',
      types: [
        POSITION_IMPORT_REQUEST,
        POSITION_IMPORT_SUCCESS,
        POSITION_IMPORT_FAILURE,
      ],
      headers: {
        'authorization': `bearer ${access_token}`,
      },
      body: payload,
    },
  }
}

export function resetListPosition() {
  return {
    type: POSITION_LIST_RESET,
  }
}


export function resetCreatePosition() {
  return {
    type: POSITION_CREATE_RESET,
  }
}

export function resetEditPosition() {
  return {
    type: POSITION_EDIT_RESET,
  }
}

export function resetGetPosition() {
  return {
    type: POSITION_GET_RESET,
  }
}

export function resetDeactivatePosition() {
  return {
    type: POSITION_DEACTIVATE_RESET,
  }
}

export function resetExportPosition() {
  return {
    type: POSITION_EXPORT_RESET,
  }
}

export function resetImportPosition() {
  return {
    type: POSITION_IMPORT_RESET,
  }
}




// WEBPACK FOOTER //
// ./src/actions/position/position-action.js